import type { TrackStructureFull } from '@devlearn/shared';
import values from './01-values/chapter';
import functions from './02-functions/chapter';
import async from './03-async/chapter';
import objects from './04-objects/chapter';
import arrays from './05-arrays/chapter';
import modules from './06-modules/chapter';

export const jsFundamentals: TrackStructureFull = {
  id: 'js-fundamentals',
  slug: 'js-fundamentals',
  title: 'JavaScript Fundamentals',
  shortTitle: 'JS Fundamentals',
  position: 1,
  status: 'available',
  chapters: [values, functions, async, objects, arrays, modules],
};
